import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=3a6b6666&scoped=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Item.vue?vue&type=style&index=0&id=3a6b6666&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3a6b6666",
  "a3c0f136"
  
)

export default component.exports